import { useState, useEffect } from "react";
import { useBudget } from "@/hooks/use-budget";
import { BudgetRow, transformApiAccountToBudgetRow, groupAccountsWithSubtotals } from "@/components/budget/types";

export const useBudgetEditor = (
  open: boolean,
  clientId: string,
  connectionId: string,
  budgetId: string
) => {
  const { getBudget, updateExistingBudget, isUpdating, updateSuccess, updateError } = useBudget(clientId, connectionId);
  const { data: budgetData, isLoading: queryIsLoading, isError } = getBudget(open ? budgetId : null);
  const [rows, setRows] = useState<BudgetRow[]>([]);
  const [changedFields, setChangedFields] = useState<Set<string>>(new Set());
  const [originalRows, setOriginalRows] = useState<BudgetRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!open) {
      setRows([]);
      setChangedFields(new Set());
      setOriginalRows([]);
      return;
    }

    setIsLoading(true);

    if (budgetData?.accounts) {
      const transformedRows = budgetData.accounts.map(transformApiAccountToBudgetRow);
      const groupedRows = groupAccountsWithSubtotals(transformedRows);
      setRows(groupedRows);
      setOriginalRows(groupedRows);
      setIsLoading(false);
    }
  }, [open, budgetData]);

  return {
    budgetData,
    isLoading: isLoading || queryIsLoading,
    isError,
    rows,
    setRows,
    changedFields,
    setChangedFields,
    originalRows,
    setOriginalRows,
    updateExistingBudget,
    isUpdating,
    updateSuccess,
    updateError
  };
};